'use strict';

var big = require('./big.js');

const NumberFormatHelper = (number, { locale, ...options })=>{
    // Number format instance
    const instance = new Intl.NumberFormat(locale, options);
    // Mutable number parts
    let numberParts = instance.formatToParts(number);
    // Extract number config parts
    const numberConfig = numberParts.reduce((acc, { type, value })=>{
        if (type !== 'integer') {
            acc[type] = value;
        }
        return acc;
    }, {});
    return {
        /**
         * Get Number Parts.
         */ get: numberConfig,
        /**
         * Update number config type only if exists.
         */ set: (type, value)=>{
            if (type in numberConfig) {
                numberConfig[type] = value;
            }
        },
        /**
         * Remove number config type.
         */ remove: (type)=>{
            numberParts = numberParts.filter((part)=>part.type !== type);
        },
        /**
         * Combine base parts with config parts
         * and compile the formatted number.
         */ format: ()=>{
            return Object.values(numberParts).map(({ type, value })=>{
                // Skip on `integer`, use part config for the rest
                // - integer is a repeated key, hence we exclude it
                return type === 'integer' ? value : numberConfig[type] ?? '';
            }).join('').trim();
        }
    };
};
const getFormatParts = (amount, decimalPlaces, condensed = false)=>{
    const MINIMUM_THRESHOLD = 0.0001;
    const THOUSAND = 1000;
    // Default number parts
    const defaultParts = {
        amount,
        decimalPlaces,
        denomination: '',
        prefixSymbol: ''
    };
    // Return original format parts if not in condensed mode
    if (!condensed) {
        return defaultParts;
    }
    const numAmount = Number(amount);
    const absAmount = Math.abs(numAmount);
    // Between (0, 0.0001)
    if (0 < absAmount && absAmount < MINIMUM_THRESHOLD) {
        return {
            amount: Math.sign(numAmount) * MINIMUM_THRESHOLD,
            decimalPlaces: 4,
            denomination: '',
            prefixSymbol: '<'
        };
    }
    // Between [0.0001, 1)
    if (MINIMUM_THRESHOLD <= absAmount && absAmount < 1) {
        return {
            ...defaultParts,
            amount: numAmount,
            decimalPlaces: 4
        };
    }
    // Between [1, thousand)
    if (1 <= absAmount && absAmount < THOUSAND) {
        return {
            ...defaultParts,
            amount: numAmount,
            decimalPlaces: 2
        };
    }
    // Between [thousand, inf)
    if (THOUSAND <= absAmount) {
        const { numValue, denom } = big.classifyAmount(numAmount);
        return {
            amount: numValue,
            denomination: denom,
            prefixSymbol: '≈',
            decimalPlaces: 1
        };
    }
    return defaultParts;
};

exports.NumberFormatHelper = NumberFormatHelper;
exports.getFormatParts = getFormatParts;
//# sourceMappingURL=numberFormat.js.map
